// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"871ed923","732":"67ff12b7","977":"edc0665a"}[chunkId] + ".chunk.js");